<template>
  <div id="equipment">
    <div v-if="!is_preview || (is_preview && equipment.primary_color != '')">
      <Shirt
        :primary_color="equipment.primary_color"
        :type="equipment.type"
        :secondary_color="equipment.secondary_color"
      ></Shirt>
      <Shorts :color="equipment.pants_color"></Shorts>
      <Socks :color="equipment.socks_color"></Socks>
    </div>
    <div v-if="!is_preview">
      <label
        >{{ $t("params.primary_color") }} <span class="obligatory">*</span>
      </label>
      <select v-if="!error.primary_color" v-model="equipment.primary_color">
        <option v-for="color in colors" v-bind:value="color" v-bind:key="color">
          {{ $t("colors." + color) }}
        </option>
      </select>
      <select v-else v-model="equipment.primary_color" class="error">
        <option v-for="color in colors" v-bind:value="color" v-bind:key="color">
          {{ $t("colors." + color) }}
        </option>
      </select>
    </div>
    <div v-if="!is_preview">
      <label>{{ $t("params.type") }} <span class="obligatory">*</span> </label>
      <select v-if="!error.type" v-model="equipment.type">
        <option v-for="type in types" v-bind:value="type" v-bind:key="type">
          {{ $t("equipment_type." + type) }}
        </option>
      </select>
      <select v-else v-model="equipment.type" class="error">
        <option v-for="type in types" v-bind:value="type" v-bind:key="type">
          {{ $t("equipment_type." + type) }}
        </option>
      </select>
    </div>
    <div v-if="equipment.type != 'one_colour' && !is_preview">
      <label
        >{{ $t("params.secondary_color") }} <span class="obligatory">*</span>
      </label>
      <select v-if="!error.secondary_color" v-model="equipment.secondary_color">
        <option v-for="color in colors" v-bind:value="color" v-bind:key="color">
          {{ $t("colors." + color) }}
        </option>
      </select>
      <select v-else v-model="equipment.secondary_color" class="error">
        <option v-for="color in colors" v-bind:value="color" v-bind:key="color">
          {{ $t("colors." + color) }}
        </option>
      </select>
    </div>
    <div v-if="!is_preview">
      <label
        >{{ $t("params.pants_color") }} <span class="obligatory">*</span>
      </label>
      <select v-if="!error.pants_color" v-model="equipment.pants_color">
        <option v-for="color in colors" v-bind:value="color" v-bind:key="color">
          {{ $t("colors." + color) }}
        </option>
      </select>
      <select v-else v-model="equipment.pants_color" class="error">
        <option v-for="color in colors" v-bind:value="color" v-bind:key="color">
          {{ $t("colors." + color) }}
        </option>
      </select>
    </div>
    <div v-if="!is_preview">
      <label
        >{{ $t("params.socks_color") }} <span class="obligatory">*</span>
      </label>
      <select v-if="!error.socks_color" v-model="equipment.socks_color">
        <option v-for="color in colors" v-bind:value="color" v-bind:key="color">
          {{ $t("colors." + color) }}
        </option>
      </select>
      <select v-else v-model="equipment.socks_color" class="error">
        <option v-for="color in colors" v-bind:value="color" v-bind:key="color">
          {{ $t("colors." + color) }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Shirt from "@/components/equipment/Shirt.vue";
import Shorts from "@/components/equipment/Shorts.vue";
import Socks from "@/components/equipment/Socks.vue";

export default {
  name: "Equipment",
  components: {
    i18n,
    Shirt,
    Shorts,
    Socks
  },
  props: ["equipment", "error", "number", "is_preview"],
  data() {
    return {
      colors: [
        "yellow",
        "blue",
        "LightBlue",
        "white",
        "maroon",
        "grey",
        "violet",
        "brown",
        "orange",
        "black",
        "red",
        "pink",
        "green",
        "mediumpurple",
        "darkblue",
        "#134957",
        "#207085",
        "#efb810",
        "#AAEF79",
        "salmon"
      ],
      types: [
        "one_colour",
        "horizontal_stripes",
        "vertical_stripes",
        "diagonal_strip",
        "inverted_chevron",
        "arlequine"
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
#equipment {
  display: block;
  width: 100%;

  div {
    width: 100%;
  }

  input,
  select {
    width: 100%;
    padding: 0;
    margin-bottom: 0;
    border: 1px solid $secondary-color;
    outline: none;
    font-size: 11pt;
    border-radius: 3px;
    padding: 10px;
    margin: 5px 0;
  }

  select option {
    font-size: 14pt;
  }

  select {
    -webkit-appearance: menulist;
  }

  label {
    font-size: 14px;
    padding: 0;
    margin-bottom: 5px;
    display: block;
  }

  .obligatory {
    color: $alert-color;
    font-weight: bold;
  }

  .error {
    border-color: $alert-color;
    &::placeholder {
      color: $alert-color;
      opacity: 0.5;
    }
  }
}
</style>
